<script>
	export default {
		name: 'ContactExecuter',
		methods: {
			getContacts() {
				const self_ = this;

				const uid_ = self_.getCurrentUser('uid')

				const filter_ = {
					field: 'user.' + uid_,
					operator: '==',
					value: true
				}

				return self_.getFirestoreCollection('contacts', filter_, 0)
			}
		}
	}
</script>